import {Component} from '@angular/core';
/**
 * \@title Paginator
 */
export class PaginatorOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'paginator-overview-example',
  templateUrl: 'paginator-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PaginatorOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
PaginatorOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PaginatorOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
